export const SPLASHVAL = 'SPLASHVAL';

export const SplashScreen = (flag) => async (dispatch) => {
    dispatch({
        type: SPLASHVAL,
        payload: flag,
    });
}
